import { FavoritesList } from '../features/favorites';
import useWootricSurvey from '../hooks/useWootricSurvey';
import { jsx as _jsx } from "react/jsx-runtime";
export const Favorites = () => {
  useWootricSurvey('CSAT');
  return /*#__PURE__*/_jsx(FavoritesList, {});
};
export default Favorites;